import { WarrantyModal } from '@digital-retail/warranty-library';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { trackWarrantyRejectionXLP, trackWarrantySelectionXLP } from '../components/Cart/Cart.Utils';
import { Drawer } from '../components/ui/Drawer/Drawer';
import { Modal } from '../components/ui/Modal/Modal';
import { getWarrantyBenefits } from '../components/ui/WarrantySelect/WarrantySelect.helpers';
import { withApplicationContext } from './ApplicationContext';
import { withCart } from './CartContext';
import { withProduct } from './ProductContext';

const Warranty = ({ cart, appCtx, product, item, isVisible, onClose, onWarrantySelected }) => {
  const [showModal, setShowModal] = useState(false);
  const [warrantyBenefits, setWarrantyBenefits] = useState([]);
  const { deviceType } = appCtx;
  const isDesktop = deviceType === 'desktop';

  useEffect(() => {
    setShowModal(isVisible);
  }, [isVisible]);

  useEffect(() => {
    if (item) {
      const gCategoryId =
        item?.GSCCategoryId ||
        item?.attributes?.GSCCategoryId ||
        product?.GSCCategoryId ||
        product?.attributes?.GSCCategoryId ||
        '';
      const regionCode = appCtx?.regionCode || 'cl';

      const benefits = getWarrantyBenefits({
        siteConfig: appCtx?.siteConfig,
        regionCode,
        gCategoryId,
      });

      setWarrantyBenefits(benefits);
    }
  }, [item, appCtx, product]);

  const benefitsLabels = {
    WARRANTY_BENEFITS_LABEL:
      appCtx?.siteConfig?.textDictionary?.WARRANTY_BENEFITS_LABEL ?? 'Beneficios de extender la garantía',
    MORE_WARRANTY_BENEFITS: appCtx?.siteConfig?.textDictionary?.MORE_WARRANTY_BENEFITS ?? 'Más beneficios',
    RECOMMENDED_WARRANTY: appCtx?.siteConfig?.textDictionary?.RECOMMENDED_WARRANTY ?? '¡Recomendado!',
    PDP_NO_THANKS: appCtx?.siteConfig?.textDictionary?.PDP_NO_THANKS ?? 'Sin garantía extendida',
    WARRANTY_ADDED: appCtx?.siteConfig?.textDictionary?.WARRANTY_ADDED ?? 'Agregado',
    WARRANTY_LABEL_TEMPLATE: appCtx?.siteConfig?.textDictionary?.WARRANTY_LABEL_TEMPLATE ?? '{warrantyName}',
    EXTENDED_WARRANTY_TITLE: appCtx?.siteConfig?.textDictionary?.EXTENDED_WARRANTY_TITLE ?? 'Protege tu producto',
  };

  const handleWarrantySelection = (warrantyOption) => {
    setShowModal(false);
    const productSku = item?.skuId || product?.currentVariant || product?.skuId || '';

    if (warrantyOption) {
      const warrantySku = warrantyOption.value || warrantyOption.variantId || warrantyOption.id || '';
      trackWarrantySelectionXLP(productSku, warrantyOption.name, warrantySku);

      cart.setWarrantyOptionCurrent({ ...warrantyOption, selected: true });

      if (onWarrantySelected) {
        onWarrantySelected(warrantyOption, item);
      }
    } else {
      trackWarrantyRejectionXLP(productSku);

      if (onWarrantySelected) {
        onWarrantySelected(null, item);
      }
    }

    if (onClose) {
      onClose();
    }
  };

  if (!item) {
    return null;
  }

  const hasWarrantyOptions = item.warrantyOptions?.fieldOptions && item.warrantyOptions.fieldOptions.length > 0;

  if (!hasWarrantyOptions) {
    return null;
  }
  const transformedOptions = (item.warrantyOptions?.fieldOptions || []).map((option) => ({
    ...option,
    name: option.textLabel,
  }));

  try {
    return (
      <WarrantyModal
        appCtx={appCtx}
        options={transformedOptions}
        showModal={showModal}
        setShowModal={(visible) => {
          setShowModal(visible);
          if (!visible && onClose) onClose();
        }}
        handleWarrantyChange={handleWarrantySelection}
        product={item}
        isExtendedWarranty
        modalComponent={Modal}
        drawerComponent={isDesktop ? null : Drawer}
        warrantyBenefits={warrantyBenefits}
        benefitsLabels={benefitsLabels}
      />
    );
  } catch (error) {
    return null;
  }
};

Warranty.defaultProps = {
  isVisible: false,
  onClose: () => {},
  onWarrantySelected: () => {},
  item: null,
};

Warranty.propTypes = {
  cart: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  onWarrantySelected: PropTypes.func,
  item: PropTypes.object,
};

export default withApplicationContext(withProduct(withCart(Warranty)));
export { Warranty };
